<template>
  <v-row align="center" justify="center">
    <v-col class="text-center">
      <GetStarted v-if="firstRun()" />
      <UserTabs v-else />
    </v-col>
  </v-row>
</template>
<script>
// @ is an alias to /src
import GetStarted from "@/components/GetStarted";
import UserTabs from "@/components/UserTabs";
import { mapGetters } from "vuex";
export default {
  name: "Home",
  components: {
    GetStarted,
    UserTabs
  },
  data: () => ({}),
  computed: {
    ...mapGetters(["getAccountState", "getUserList"])
  },
  methods: {
    firstRun() {
      if (this.getAccountState) {
        if (this.getUserList && this.getUserList.length > 0) return false;
        else return true;
      } else {
        return false;
      }
    }
  },
  mounted() {}
};
</script>
